<app-table
    [data]="complianceLocationQualificationData"
    [columns]="complianceLocationQualificationColumns"
></app-table>